// src/types.ts
/**
* Array of all days of the week in order (Sunday first)
*/
var DAYS_OF_WEEK = [
	"sunday",
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday",
	"saturday"
];
/**
* Display labels for each day of the week
*/
var DAY_LABELS = {
	friday: "Friday",
	monday: "Monday",
	saturday: "Saturday",
	sunday: "Sunday",
	thursday: "Thursday",
	tuesday: "Tuesday",
	wednesday: "Wednesday"
};
export { DAYS_OF_WEEK, DAY_LABELS };

//# sourceMappingURL=types.js.map